import { API } from '@/api/index';

export default {
    name: "Header",
    created() {
        this.$nextTick(function () {

            const urlParams = new URLSearchParams(window.location.search);

            let Langa = urlParams.get('lang') || "";

            // 假設有 lang
            if (Langa.toUpperCase() != "" && (Langa.toUpperCase() == this.LANGUAGE1 || Langa.toUpperCase() == this.LANGUAGE2)) {

                Langa = Langa.toUpperCase();
                if (Langa.toUpperCase() == this.LANGUAGE1) {
                    localStorage.setItem('Language', 1)

                } else if (Langa.toUpperCase() == this.LANGUAGE2) {
                    localStorage.setItem('Language', 2)
                }
            }

            // 假設沒有 lang 或 不正確
            else {
                let currentUrl = new URL(window.location.href)
                if (localStorage.getItem("Language") != "" && localStorage.getItem("Language") != undefined) {

                    if (localStorage.getItem("Language") == 1) {
                        Langa = this.LANGUAGE1;
                        currentUrl.searchParams.set('lang', this.LANGUAGE1);
                    } else {
                        if (this.LANGUAGE2 != "") {
                            Langa = this.LANGUAGE2;
                            currentUrl.searchParams.set('lang', this.LANGUAGE2);
                        } else {
                            Langa = this.LANGUAGE1;
                            currentUrl.searchParams.set('lang', this.LANGUAGE1);
                        }

                    }

                } else {

                    if (process.env.VUE_APP_DEFAULT == "1") {
                        localStorage.setItem('Language', 1)
                        Langa = this.LANGUAGE1;
                        currentUrl.searchParams.set('lang', this.LANGUAGE1);
                    }
                    else if (process.env.VUE_APP_DEFAULT == "2") {
                        if (this.LANGUAGE2 != "") {
                            localStorage.setItem('Language', 2)
                            Langa = this.LANGUAGE2;
                            currentUrl.searchParams.set('lang', this.LANGUAGE2);
                        } else {
                            localStorage.setItem('Language', 1)
                            Langa = this.LANGUAGE1;
                            currentUrl.searchParams.set('lang', this.LANGUAGE1);
                        }

                    }
                    else {
                        Langa = this.LANGUAGE1;
                        currentUrl.searchParams.set('lang', this.LANGUAGE1);
                    }
                }
                window.location.href = currentUrl
            }



            document.querySelector("html").setAttribute("lang", Langa.toUpperCase());
            $(document).on('click', function (e) {
                if (!$(e.target).closest('.hmega_toggle').length && !$(e.target).closest('.megaheader').length) {
                    jQuery('.megaheader').removeClass(`active`);
                    $('.hmega_toggle').removeClass('submenumenushow');
                }
                $("body").removeClass('megashow');
            });

            this.GetMenu()
        });
    },
    mounted() {
        this.$nextTick(function () {
            $('.selectHeader').on('select2:select', this.handleSelect2Click);
            console.log(this.Select2IMG);

        })
    },
    updated() {

    },
    data() {
        return {
            Data: [],
            Login: [],
            Open: [],
            SearchValue: '',
            Select2IMG: {
                'ID': { name: this.$t('Indo'), img: require('../../assets/images/IndonesiaIcon.svg') },
                'SG': { name: this.$t('Sing'), img: require('../../assets/images/SingaporeIcon.svg') },
                'MY': { name: this.$t('Mala'), img: require('../../assets/images/MalaysiaIcon.svg') },
                'IN': { name: this.$t('Inte'), img: require('../../assets/images/cgsi-icon.png') },
                'TH': { name: this.$t('Thai'), img: require('../../assets/images/ThailandIcon.svg') },
                'MU': { name: this.$t('Thai'), img: require('../../assets/images/ThailandIcon.svg') },
            },
            LanguageT: localStorage.getItem('Language') || process.env.VUE_APP_DEFAULT,
            LANGUAGE1: process.env.VUE_APP_LANGUAGE1,
            LANGUAGE2: process.env.VUE_APP_LANGUAGE2,
            REGION: process.env.VUE_APP_REGION,
            TITLE: process.env.VUE_APP_TITLE,
            NavActive: null,
            NavActiveif: false,
            tabContent: 0
        };
    },
    computed: {

    },
    watch: {

    },
    methods: {
        async GetMenu() {


            try {
                const result = await API.get(this.REGION == 'IN' ? 'GetMenuIntl' : 'GetMenu', { lang: localStorage.getItem('Language') || '1' });
                this.Data = result.data;
                if (this.REGION != 'IN') {
                    this.Login = result.login.login
                    this.Open = result.open.open
                }

            } catch (error) {
                this.Data = []
                console.error('API Error:', error);
            } finally {
                setTimeout(() => {
                    $.each(this.Data, (i, c) => {
                        if (jQuery(window).width() < 767) {
                            jQuery('.megaheader .tab-pane').removeClass('show');
                            jQuery('.megaheader .tab-pane').removeClass('active');
                            jQuery('.megaheader ul li > a').removeClass('active');
                            if (c.level == 3) {
                                $(`.megaheader[data-menu="menu${i + 1}"]`).detach().appendTo(`.hmega_toggle[data-menu="menu${i + 1}"]`);
                            }
                        }
                        // 初始化所有带有 data-simplebar 属性的元素
                        if ($('.simplebar-content').height() > $('.simplebar-content-wrapper').height()) {
                            const simplebars = document.querySelectorAll('[data-simplebar]');
                            simplebars.forEach(el => {
                                new SimpleBar(el);
                            });
                        }
                    })
                }, 10)
                this.Login = this.Login.map((item, index) => {
                    return {
                        ...item,
                        // 如果没有id，创建一个唯一标识
                        id: index
                    };
                });
                this.Open = this.Open.map((item, index) => {
                    return {
                        ...item,
                        // 如果没有id，创建一个唯一标识
                        id: index
                    };
                });


                $(".togglemenu").on('click', function (e) {
                    if ($("body").hasClass("menushow"))
                        $('header').css('background', 'var(--bodybg)');
                    else
                        $('header').css('background', '');
                });
                $('.hmega_toggle').each((i, c) => {
                    let menuId = $(c).data('menu'); // e.g., "menu1"
                    let $megaHeader = $('.megaheader[data-menu="' + menuId + '"]');
                    $megaHeader.css({
                        'left': $(c).offset().left + 'px',
                        'margin-left': 0
                    })
                })
            }
        },

        handleSelect2Click: function (e) {
            if (e.params.data.id != '/') {
                console.log('GTM 23', `'event': 'country_switch'`, `'location_name': ${e.params.data.text.trim()} 'action_data': 'header'`);
                gtag('event', 'country_switch', {
                    'location_name': e.params.data.text.trim(),
                    'action_data': 'header'
                });

                window.open(e.params.data.id, '_blank');
            }
        },
        formSubmitGTM: function () {
            console.log('GTM 24', `'event': 'language_switch'`, `'location_name': ${window.location.href} 'action_data': 'header'`, `'language_name':${this.LanguageT == 1 ? this.LANGUAGE1 : this.LANGUAGE2},`);
            gtag('event', 'language_switch', {
                'location_name': window.location.href,
                'language_name': this.LanguageT == 1 ? this.LANGUAGE1 : this.LANGUAGE2,
                'action_data': 'header'
            });

        },
        LanguageClick: function (Language) {
            this.LanguageT = Language
            localStorage.setItem('Language', Language)
        },
        GetText: function () {
            localStorage.setItem('searchText', this.SearchValue)
            window.location.href = '/search-result'
        },
        MegaheaderRemoveClass: function (actf) {
            if (actf) {
                $('.h-dropdown-wrap').toggleClass('dshow');
            }

            $('.megaheader').removeClass(`active`);
            $("body").removeClass('lngncnboxopen');
            $("body").removeClass('megashow');

            $("body").removeClass('searchopen');
            $(".hoverlay").toggleClass('show');
            if ($(window).width() > 767) {
                $("body").removeClass('menushow');

            }


        },
        LngncnboxClick: function () {
            $("body").toggleClass('lngncnboxopen');
            $("body").removeClass('megashow');
            $("body").removeClass('searchopen');
            $(".h-dropdown-wrap").removeClass('dshow');
            $(".hoverlay").toggleClass('show');
            // this.MegaheaderRemoveClass()
        },

        Megaback: function (index) {
            this.tabContent = index
        },
        Megaback2: function (box, index) {
            this.tabContent = 0
            console.log($(box).find(`#mega2mtab${index}`));

            $(box).find(`#mega2mtab${index}`).removeClass('show');
            $(box).find(`#mega2mtab${index}`).removeClass('active');
            jQuery('.megaheader ul li > a').removeClass('active');
        },

        MenuparentCilck: function (level, index, box) {

            // e.preventDefault();
            // e.stopPropagation();
            this.tabContent = 0
            // $(".level3menu").unbind();
            // $(".level3menu").on('click', function (e) {
            //   const $toggle = $(e.target).closest('.hmega_toggle');
            //   setTimeout(() => {
            //     $toggle.addClass('submenumenushow');
            //   }, 0)
            // });

            if (level == 2) {


                let $parent = $('.menubar').find('.menLi').eq(index);

                $parent.toggleClass('submenumenushow')
                    .siblings('.menuparent').removeClass('submenumenushow');


                this.MegaheaderRemoveClass(false)

            } else if (level == 3) {



                const $toggle = $('.menubar').find('.menLi').eq(index);
                console.log($toggle);

                const menuId = $toggle.data('menu'); // e.g., "menu1"

                const $megaHeader = $('.megaheader[data-menu="' + menuId + '"]');
                $megaHeader.css({
                    'left': $toggle.offset().left + 'px',
                    'margin-left': 0
                })

                $megaHeader.toggleClass('active').siblings('.megaheader').removeClass('active');
                $toggle.toggleClass('submenumenushow').siblings('.menuparent').removeClass('submenumenushow');

                // Remove open class from all toggles
                // $('.hmega_toggle').removeClass('submenumenushow');

                // Toggle the selected one
                if ($(window).width() > 767) {

                    jQuery(".h-dropdown-wrap").removeClass('dshow');
                    jQuery("body").removeClass('lngncnboxopen');
                }
            }
            if ($(window).width() > 767) {


                let $e = $('.menubar').find('.menLi').eq(index);
                if ($e.hasClass('submenumenushow')) {
                    jQuery("body").addClass('megashow')
                } else {
                    jQuery("body").removeClass('megashow')
                }

            }
        }
    },

    components: {

    }
};